var _defs, _path, _path2, _path3, _ellipse, _ellipse2, _line, _line2, _line3;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTrackAndTraceTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 3",
    id: "Layer_3",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:white;stroke-linecap:round;stroke-linejoin:round;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.94,9V22.6H13.28a2.42,2.42,0,0,0-4.83,0H6V9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,17.8v4.8H29.39a2.42,2.42,0,0,0-4.83,0H22.94V13h3.37Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,17.8v4.8H29.39a2.42,2.42,0,0,0-4.83,0H22.94V17.8Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 10.86,
    cy: 22.6,
    rx: 2.42,
    ry: 2.4
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 26.97,
    cy: 22.6,
    rx: 2.42,
    ry: 2.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1,
    x2: 3.61,
    y1: 10.6,
    y2: 10.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1,
    x2: 3.61,
    y1: 13.8,
    y2: 13.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1,
    x2: 3.61,
    y1: 17,
    y2: 17
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackAndTraceTruck);
export default __webpack_public_path__ + "static/media/trackAndTraceTruck.10589bba872fa3fd7e620c1d7fbf4d09.svg";
export { ForwardRef as ReactComponent };